export default {
  production: '643946fcb827fb03bdb2746c',
  development: '643e72ae7bd72a038d982b0c',
  test: '643e72ae7bd72a038d982b0c',
};
